<template>
  <v-footer
    v-if="visible"
    id="dashboard-core-footer"
    outlined
    color="#DCDCDC"
    padless
    app
    inset
    style="z-index: 1024;"
  >
      <v-container :class="'footer-container'" @click="changeFooter">
        <p style="margin-bottom: 0;">{{ hitokoto }}</p>
        <small style="font-style: italic;">{{ from }}</small>
      </v-container>
  </v-footer>
</template>

<script>
  export default {
    name: 'DashboardCoreFooter',

  data: () => ({
    hitokoto: '',
    from: '',
    visible: true,
  }),
  created() {
    fetch('https://laplace.live/api/hitokoto', { referrer: 'laplace.live' })
      .then(resp => resp.json())
      .then(data => {
        this.hitokoto = data.hitokoto
        this.from = data.from_who + (data.from === '' ? '' : ' ') + data.from
        //this.hitokoto = '我的人生奋斗的动力，可能和大家不太一样；大家可能是梦想，我没有梦想，我人生的终极梦想是摆烂。我所有所有前进的动力，来源我的不甘心；来源我的愤怒；来源我的浪漫主义被人摧残、折磨；来源于我前面20年受过的所有痛苦。我前进是为了以后更舒服的摆烂，是为了磨平我心里的不甘心，是为了让我自己放下'
      })
      .catch(e => {
        this.hitokoto = '加载失败'
        this.from = ''
      })
  },
  methods: {
    changeFooter() {
      fetch('https://laplace.live/api/hitokoto', { referrer: 'laplace.live' })
        .then(resp => resp.json())
        .then(data => {
          this.hitokoto = data.hitokoto
          this.from = data.from_who + (data.from === '' ? '' : ' ') + data.from
          //this.hitokoto = '我的人生奋斗的动力，可能和大家不太一样；大家可能是梦想，我没有梦想，我人生的终极梦想是摆烂。我所有所有前进的动力，来源我的不甘心；来源我的愤怒；来源我的浪漫主义被人摧残、折磨；来源于我前面20年受过的所有痛苦。我前进是为了以后更舒服的摆烂，是为了磨平我心里的不甘心，是为了让我自己放下'
        })
        .catch(e => {
          this.hitokoto = '加载失败'
          this.from = ''
        }) 
    },
  }
}
</script>

<style lang="sass">
  .footer-container
    margin: 0px
    margin-left: 3%
    padding: 0px
  .close-btn
    background-color: transparent !important
    color: transparent !important
  #dashboard-core-footer
    a
      font-size: .825rem
      font-weight: 500
      text-decoration: none
      text-transform: uppercase
</style>
